<div>
  <div class="dialog-body">
    @if (grantsCount > 1) {
      <div class="dialog-content-description gea-font-body-20">Are you sure you want to remove the selected grants?</div>

      <div class="dialog-content-description gea-font-body-20 mb-3">This action cannot be undone.</div>
    } @else {
      <div class="dialog-content-description gea-font-body-20">
        Are you sure you want to remove
        <b> `{{ grants[0].grant }}` </b>
        for
        <b> `{{ grants[0].target }}` </b>
        ?
      </div>

      <div class="dialog-content-description gea-font-body-20 mb-3">This action cannot be undone.</div>
    }
  </div>

  <div class="p-dialog-footer mb-3">
    <geaui-button-v3 [disabled]="deletingGrants()" (click)="onCancel()" type="secondary"> Cancel </geaui-button-v3>
    <geaui-button-v3 [sending]="deletingGrants()" (click)="onConfirm()" information="error">
      Remove Selected ({{ grantsCount }})
    </geaui-button-v3>
  </div>
</div>
